import { MDXProvider } from '@mdx-js/react';
import { ReactNode } from 'react';
import components from './mdx-components-map';

// Custom components for MDX elements
type MDXComponents = Record<string, React.ComponentType<Record<string, unknown>>>;

interface MdxComponentsProviderProps {
  children: ReactNode;
  components?: MDXComponents;
}

export const MdxComponentsProvider: React.FC<MdxComponentsProviderProps> = ({
  children,
  components: customComponents
}) => {
  return (
    <MDXProvider components={{ ...components, ...customComponents }}>
      {children}
    </MDXProvider>
  );
};


